import styled from 'styled-components';

import media from '../../../styles/media.style';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING, WHITE, PAGE_WIDTH, BLACK } from '../../../styles/variables.style';

export const Wrapper = styled.section`
  background-color: ${({ color }) => color};
  margin: 0 auto 60px auto;
  padding: 0 ${MOBILE_PADDING}px 20px;
  width: 100%;

  main div section + & {
    margin-top: ${MOBILE_PADDING}px;

    ${media.tabletL`
      margin-top: 0;
    `};
  }

  ${media.tabletL`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 1000px;
    max-width: ${PAGE_WIDTH}px;
    margin: 0 auto;
    padding: 0;

    ::after {
      content: '';
      display: ${({ showSecondaryImage }) => (showSecondaryImage ? 'block' : 'none')};
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url(${({ image }) =>
        image ? `${image.url}?w=${Math.floor(image.details.image.width / 3)}&q=100` : 'unset'});
      border: 40px solid ${WHITE};
      bottom: 0;
      height: 300px;
      left: 50%;
      pointer-events: none;
      position: absolute;
      transform: translate(-50%, 50%);
      width: 300px;
      z-index: 90;
    }
  `};

  ${media.x2`
    ::after {
      background-image: url(${({ image }) =>
        image ? `${image.url}?w=${Math.floor(image.details.image.width / 1.5)}&q=100` : 'unset'});
    }
  `};

  ${media.x3`
    ::after {
      background-image: url(${({ image }) => (image ? `${image.url}` : 'unset')});
    }
  `};
`;

export const TitleBottomWrapper = styled.div`
  margin: 0;
`;

export const TitleBottom = styled.h5`
  font-size: 22px;
  font-weight: 500;
  margin: 20px auto 10px;
  color: ${BLACK};
  text-transform: uppercase;

  ${media.tabletL`
    font-size: 30px;
  `};
`;

export const SectionTitleWrapper = styled.div`
  margin: 0;
`;

export const SectionTitle = styled.h5`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: 0.9px;
  margin: 0 auto 50px;
  text-align: center;
  color: ${BLACK};
  text-transform: uppercase;

  ${media.tabletL`
    font-size: 18px;
    line-height: 20px;
    letter-spacing: 0.7px;
    margin: 0 auto 85px;
  `};

  &::after {
    content: '';
    position: absolute;
    bottom: -25px;
    width: 40px;
    height: 2px;
    left: calc(50% - 20px);
    background: ${BLACK};
  }
`;

export const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: ${({ direction }) => (direction === 'row' ? 'space-between' : 'flex-start')};

  ${media.tabletL`
    width: 1000px;
    margin-bottom: 50px;
  `};
`;

export const ContentsLeft = styled.div`
  width: 100%;

  ${media.tabletL`
    width: calc(50% - 20px);
  `};
`;

export const SliderWrapper = styled.div`
  width: 100%;
`;

export const ContentWrapper = styled.div`
  ${media.tabletL`
    display: flex;
    width: calc(50% - 20px);
    flex-direction: column;
    justify-content: flex-start;
    order: ${({ left }) => (left ? '-1' : '0')};
    text-align: left;
  `};
`;

export const Title = styled.h2`
  margin: 30px 0 20px 0;

  ${media.tabletL`
    margin: 0 0 30px 0;
  `};
`;

export const MarkdownStyle = styled.div`
  > p {
    margin: 0;
    font-size: 24px;
    line-height: 26px;
    text-transform: uppercase;
    color: ${BLACK};

    ${media.tabletL`
      font-size: 30px;
      line-height: 32px;
    `};
  }
`;

export const Description = styled.div`
  margin-bottom: 30px;

  ${media.tabletL`
    margin-bottom: 32px;
  `};

  table {
    font-size: 14px;
    color: ${BLACK};
    ${media.tabletL`
      font-size: 18px;
    `};
  }

  th {
    width: 50%;
    padding: 10px 10px 10px 0;
    font-weight: 600;
    vertical-align: baseline;
    ${media.tabletL`
      width: 30%;
    `};
  }

  td {
    padding: 10px 0;
    a {
      white-space: pre-wrap;
      word-break: break-all;
    }
  }

  h1,
  h2,
  h3,
  p {
    font-size: 14px;
    font-weight: 400;
    margin: 20px 0 0 0;
    color: ${BLACK};
    word-wrap: break-word;

    ${media.tabletL`
      font-size: 18px;
      margin: 0;
    `};
  }
`;

export const SecondaryImage = styled.div`
  display: none;

  ${media.tabletL`
    display: block;
  `};
`;

export const ButtonWrapper = styled.div`
  width: 220px;
  height: 48px;
  margin: 0 calc((100% - 220px) * 0.5) 0 auto;

  ${media.tabletL`
    width: 260px;
    height: 60px;
    margin: 0;
  `};
`;

export const Button = styled.div`
  align-items: center;
  background-color: ${BLACK};
  color: ${WHITE};
  display: flex;
  font-size: 14px;
  font-weight: 800;
  line-height: 53px;
  justify-content: center;
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;

  ${media.tabletL`
    line-height: 72px;
  `};
`;

export const Section = styled.section`
  margin: auto;
  max-width: 100%;
  padding: 0 0 40px;
  width: ${SCREEN_LOCKUP_WIDTH}px;

  ${media.tabletL`
    padding: 0 0 60px;
    width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/Trend/Trend.style.js